<template>
  <v-card-actions v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </v-card-actions>
</template>

<script>
export default {
  name: "BaseCardActions"
};
</script>
